import React from 'react';
import PropTypes from 'prop-types';

import PriceInline from './index';

const getCurrency = (currency, roundAmount) => {
  if (roundAmount) {
    return {
      ...currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    };
  }
  return currency;
};

const getVariant = (showTotalPrice, variant) => {
  if (!showTotalPrice) {
    return null;
  }
  return variant;
};
const PriceGroup = ({
  children,
  className,
  amount,
  nights,
  currency,
  roundAmount,
  showTotalPrice,
}) => (
  <div className={`${className || ''}`}>
    {children && <div className="text-scale-75 mb-1"> {children}</div>}
    <PriceInline
      amount={amount}
      currency={getCurrency(currency, roundAmount)}
      variant={getVariant(showTotalPrice, 'night')}
      nights={nights}
      className="text-gray-700 py-2"
    />
    <PriceInline
      amount={amount}
      currency={getCurrency(currency, roundAmount)}
      variant={getVariant(showTotalPrice, 'total')}
    />
  </div>
);

PriceGroup.propTypes = {
  // show rounded results to 0
  roundAmount: PropTypes.bool,
  showTotalPrice: PropTypes.bool,
};

PriceGroup.defaultProps = {
  showTotalPrice: true,

};

export default PriceGroup;
